/**
 * Home 页面公共配置
 * 所有品牌共享的文案
 */

export const homeCommonConfig = {
  texts: {
    searchPlaceholder: 'Search for fiction',
    seeAll: 'See All',
    loading: 'Loading...',
    noMore: 'No more ~',
  },
}
